import React from 'react';

function Loader() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black">
      <video
        src={`${process.env.PUBLIC_URL}/video/ChalnLoading.mp4`}
        autoPlay
        muted
        playsInline
        className="w-full h-full object-cover"
      />
    </div>
  );
}

export default Loader;